import { faker } from "@faker-js/faker";
import defaultValuesOld from "../scenarios/edu-scenarios";
import { getOrgApp } from "../helpers/get-orgApp";
import { getSelectedDepartmentFromAccount } from "../helpers/get-accounts";
import { regions } from "./regions";
import { get } from "lodash";
import { isArrayWithLength } from "../../utils/array-methods";

const regionCodes = regions.map((reg) => reg.RegionCode);

var instanceTypes = ["t2.medium", "t2.large", "m5.large"];

var states = ["running", "stopped"];

var osPlatforms = defaultValuesOld().osPlatform;
var serverGroups = defaultValuesOld().serverGroups;

var instanceNameType = ["FrontEnd", "Backend", "DB-Server", "DB-Staging"];
var instanceNameTypeTest = ["Test"];

export const allInstances = async (count, accountList, regionList) => {
  let instances = [];
  let orgAppDetails = await getOrgApp();
  let selectedDepartments = [];
  if (accountList && accountList.length > 0) {
    selectedDepartments = getSelectedDepartmentFromAccount(
      orgAppDetails,
      accountList
    );
  }

  for (var i = 0; i < count; i++) {
    let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
    let selectedDept = faker.helpers.arrayElement(
      selectedDepartments && selectedDepartments.length > 0
        ? selectedDepartments
        : selectedOrg.depts
    );
    let selectedDeptApp = faker.helpers.arrayElement(selectedDept.deptApps);
    let selectedDeptAccount = faker.helpers.arrayElement(
      selectedDept.deptAccounts
    );
    const isHybrid = [4, 7, 8].includes(i);
    const isAzure = [2, 5].includes(i);
    const isgcp = [3, 9, 12].includes(i);
    var osPlatform = faker.helpers.arrayElement(osPlatforms);
    const instanceName =
      selectedDept.deptCode +
      "-" +
      faker.helpers.arrayElement(
        isHybrid || isAzure || isgcp ? instanceNameTypeTest : instanceNameType
      ) +
      "-" +
      selectedDeptApp.appEnv +
      "-Server" +
      faker.helpers.arrayElement([1, 2]);

    let Apps = [];
    if (
      get(selectedDept, "deptApps") &&
      isArrayWithLength(selectedDept.deptApps)
    ) {
      Apps = selectedDept.deptApps.map((app) => app.appId);
    }

    const RegionCode =
      regionList && regionList.length
        ? faker.helpers.arrayElement(regionList)
        : faker.helpers.arrayElement(regionCodes);

    instances.push({
      InstanceType: faker.helpers.arrayElement(instanceTypes),
      Tags: [
        {
          Key: "Name",
          Value: instanceName,
        },
      ],
      ResourceId:
        isHybrid || isAzure || isgcp
          ? "mi-" + faker.random.alphaNumeric(14)
          : "i-" + faker.random.alphaNumeric(15),
      ARN: `arn:aws::instance:${RegionCode}:${faker.random.alphaNumeric(15)}`,
      Apps,
      InstanceState: faker.helpers.arrayElement(states),
      AccountNumber: selectedDeptAccount.accountNumber,
      CustomerId: faker.number.int(),
      RegionCode,
      IsDay2Managed: i === 3 || i === 5 ? false : true,
      IsManaged: i === 3 || i === 5 ? false : true,
      IsHybrid: isHybrid,
      IsAzure: isAzure,
      IsGcp: isgcp,
      UpdatedAt: faker.date.past(),
      OperatingSystem: osPlatform.os,
      ResourceName: instanceName,
      OrganizationId: selectedOrg.orgId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      Departments: [selectedDept.deptId],
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      ServerGroup: faker.helpers.arrayElement(serverGroups).name,
      Platform: osPlatform.platform,
    });
  }
  return instances;
};

export const instanceData = (instance) => {
  return {
    Monitoring: {
      State: "stopped",
    },
    PublicDnsName: "",
    StateReason: {
      Message: "Client.UserInitiatedShutdown: User initiated shutdown",
      Code: "Client.UserInitiatedShutdown",
    },
    State: {
      Code: 80,
      Name: instance.InstanceState,
    },
    ManagedInstance: instance.IsDay2Managed,
    EbsOptimized: false,
    LaunchTime: "2019-05-10 11:45:42+00:00",
    PrivateIpAddress: "172.31.35.171",
    ProductCodes: [],
    VpcId: "vpc-0d97a765",
    CpuOptions: {
      CoreCount: 1,
      ThreadsPerCore: 1,
    },
    StateTransitionReason: "User initiated (2019-05-10 11:50:03 GMT)",
    InstanceId: instance.ResourceId,
    EnaSupport: true,
    ImageId: "ami-02bcbb802e03574ba",
    PrivateDnsName: "ip-172-31-35-171.us-east-2.compute.internal",
    KeyName: "vm",
    SecurityGroups: [
      {
        GroupName: "launch-wizard-3",
        GroupId: "sg-033a9bbf9e8c8529d",
      },
    ],
    ClientToken: "",
    SubnetId: "subnet-ee7089a2",
    InstanceType: instance.InstanceType,
    CapacityReservationSpecification: {
      CapacityReservationPreference: "open",
    },
    NetworkInterfaces: [
      {
        Status: "in-use",
        MacAddress: "0a:97:ec:4c:6a:c8",
        SourceDestCheck: true,
        VpcId: "vpc-0d97a765",
        Description: "",
        NetworkInterfaceId: "eni-0c976aa9f96149cc7",
        PrivateIpAddresses: [
          {
            PrivateDnsName: "ip-172-31-35-171.us-east-2.compute.internal",
            Primary: true,
            PrivateIpAddress: "172.31.35.171",
          },
        ],
        PrivateDnsName: "ip-172-31-35-171.us-east-2.compute.internal",
        InterfaceType: "interface",
        Attachment: {
          Status: "attached",
          DeviceIndex: 0,
          DeleteOnTermination: true,
          AttachmentId: "eni-attach-06e217e47d28fab61",
          AttachTime: "2019-05-10 11:05:06+00:00",
        },
        Groups: [
          {
            GroupName: "launch-wizard-3",
            GroupId: "sg-033a9bbf9e8c8529d",
          },
        ],
        Ipv6Addresses: [],
        OwnerId: "964124927860",
        SubnetId: "subnet-ee7089a2",
        PrivateIpAddress: "172.31.35.171",
      },
    ],
    SourceDestCheck: true,
    Placement: {
      Tenancy: "default",
      GroupName: "",
      AvailabilityZone: "us-east-2c",
    },
    Hypervisor: "xen",
    BlockDeviceMappings: [
      {
        DeviceName: "/dev/xvda",
        Ebs: {
          Status: "attached",
          DeleteOnTermination: true,
          VolumeId: "vol-0c6d98dbabbbf20ff",
          AttachTime: "2019-05-10 11:05:07+00:00",
        },
      },
    ],
    Architecture: "x86_64",
    RootDeviceType: "ebs",
    RootDeviceName: "/dev/xvda",
    VirtualizationType: "hvm",
    Tags: [
      {
        Value: "19ed1081-72c8-4932-83e2-2c849975c05c",
        Key: "MontyCloudInventoryId",
      },
      {
        Value: "7ef9f209-8530-493e-95ac-f8884c819cc3",
        Key: "MontyCloudTagId",
      },
      {
        Value: instance.Tags.find((tag) => tag.Key === "Name")["Value"],
        Key: "Name",
      },
    ],
    HibernationOptions: {
      Configured: false,
    },
    AmiLaunchIndex: 0,
  };
};
